/* eslint-disable default-case */
// [ ] TOP 
import React, { useState, useEffect, useMemo, useCallback} from "react";
import { useLocation, useNavigate , useSearchParams} from "react-router-dom";
import RightSidebar from "./RightSidebar";
import BottomBar from "./BottomBar";
// import {managementStructureService} from "../requests/managementStructureService";
import { utilityService } from "../requests/utilityService";
import { useModal } from "../hooks/useModal";
import FloatingQueryCenter from "./FloatingQueryCenter";
import { managementStructureService } from "../requests/managementStrcutureService";


import "./TransactionDetail.css";
import { CorporateStructureForm } from "./forms/corporate-structure/corporateStructureForm";
import { corporateStructureApiFactory } from "../apiFactory/corporateStructureApiFactory";
import { CorporateStructureFactory } from "../factory/corporateStructureFactory";
import { corporateStructureService } from "../requests/corporateStructureService";
import { sharedData } from "../sharedData/sharedData";
import { useValidateCorporateStrcuture } from "../validations/validationHooks/useValidateCorporateStrcuture";
import { v4 as uuidv4 } from "uuid";
import { diligenceObservable } from "../observers/deligenceObservable";
import StepTabs from "./StepTabs";
import FloatingMessageCenter from "./FloatingMessageCenter";
import {RequestCertified,EmailSuccess,EmailFailed,PageValidation,SaveFailed,Validating,SaveResultMessage,ErrorMessage,DealCheck} from "../components/popups/allPopup";
import { handleAddressValidation } from "../hooks/addressValidator";
import { useValidateSingleAddress } from "../hooks/validateSingleAddress";
import AddressUpdateConfirmationModal from "./ui/AddressUpdateConfirmationModal";
import { Modal } from "./ui/Modal";

import ConfirmationModal from "./ui/ConfirmationModal";
import ErrorModal from "./ui/ErrorModal";
import LoaderModal from './Loader';
import { getNextEnabledSection } from "../utils/navigationHelper";
import { reloadAfterValidate } from "../utils/reloadAfterValidate";
import ViewModeBanner from "./ui/ViewModeBanner";
import { clientCoutnerpartyService } from "../requests/clientCounterpartyService";
import { requestService } from "../requests/requestService";
import { isUboSimplifiedTrigger, uboCountries } from "./forms/ubo-forms/controllingUboQuestion";

const UBO_SIMPLIFIED_OWNER = "corporateUboSimplified";

// A regulated / exchange-listed UBO that is the controlling or only UBO makes the
// request Simplified, unless ANY UBO's country is Enhanced (a high-risk country on
// another UBO must block it too). Enhanced from any other section still wins inside
// diligenceObservable.finalDiligence().
// One fixed owner id (not per-index) so removing or reordering UBOs can't strand an entry.
const applyUboSimplified = (ubos) =>
  // The section is already saved by now; a failure here must not show "Save failed".
  computeUboSimplified(ubos).catch((err) => console.error("UBO simplified check failed:", err));

const computeUboSimplified = async (ubos = []) => {
  const candidates = ubos.filter((u) =>
    isUboSimplifiedTrigger(u?.type, u?.data) &&
    u.data.uboControllingOwner === "Yes"
  );
  if (candidates.length > 0 && !(await anyCountryEnhanced(uboCountries(ubos)))) {
    diligenceObservable.setValue("Simplified", UBO_SIMPLIFIED_OWNER);
    return persistDiligence();
  }
  if (diligenceObservable.getValue(UBO_SIMPLIFIED_OWNER)) {
    diligenceObservable.remove(UBO_SIMPLIFIED_OWNER);
    return persistDiligence();
  }
};

const anyCountryEnhanced = async (countries) => {
  const results = await Promise.all(countries.map((c) => clientCoutnerpartyService.getDiligenceTypeByCountry(c)));
  // ponytail: no answer from the server means we can't rule out Enhanced, so treat it as Enhanced.
  return results.some((levels) => !levels || levels.some((item) => item.Diligence?.toLowerCase() === "enhanced"));
};

// The observable's own server write is debounced 500ms, and Validate reloads the page
// after 500ms, so write it here and wait for it.
const persistDiligence = () =>
  requestService.updateRequest({
    requestId: sharedData.get("requestId"),
    Diligence_Status: diligenceObservable.finalDiligence(),
  });
// BUG: We are not mapping UBO data in backend.
const CorporateStructure = ({isReport}) => {
  const navigate = useNavigate();

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [isReadOnly, setIsReadOnly] = useState(false);

  const requestId = useMemo(() => sharedData.get("requestId"), []);
  const transactionId = useMemo(() => sharedData.get("transactionId"), []);
  const propertyId = useMemo(() => sharedData.get("propertyId"), []);
  const entityId = useMemo(() => sharedData.get("entityId"), []);
  const status = useMemo(() => sharedData.get("status"), []);

  const viewMode = searchParams.get('view') === 'true'
  const editMode = searchParams.get('edit') === 'true'
const showLoader = (message) => {
  setLoadingMessage(message);
  setIsLoading(true);
};

const hideLoader = () => {
  setIsLoading(false);
  setLoadingMessage('');
};
  const [isLoading, setIsLoading] = useState(false);
const [loadingMessage, setLoadingMessage] = useState('');
const [diligenceStatus, setDiligenceStatus] = useState(sharedData.get("diligenceStatus") || "");

useEffect(() => {
  // Subscribe to diligence observable changes
  const subscription = diligenceObservable.subscribe(() => {
    setDiligenceStatus(sharedData.get("diligenceStatus") || "");
  });
  return () => subscription.unsubscribe();
}, []);

  const checkIsReadOnly = useCallback((detail) => {
    console.log(detail);
    if (!detail) return false; // Guard against undefined detail object
    const isTransactionCompleted = detail.status === "Validated";
    // ?view must lock the form. Leaving it out meant this writer, running on fetch,
    // unlocked a page the URL had put in view mode — every other page counts it.
    const isReadOnlyFromURL = searchParams.get("readonly") === "true" || searchParams.get("view") === "true";
    setIsReadOnly(isTransactionCompleted || isReadOnlyFromURL)
    return isTransactionCompleted || isReadOnlyFromURL;
  },[searchParams])
  

  const [showDropdown, setShowDropdown] = useState(null);


  const getCorporateStrucutureByEntityId = useCallback(async (entityId) => {
    try {
      const response = await corporateStructureService.getCorporateStructure(entityId);
      if (response.ok) {
        const data = CorporateStructureFactory(response.data);
        setFormData(data);
        // updateUBOState(data.uboState);
        console.log("data inside getCorporateStrucutureByEntityId:",data)
        const isReadOnly = checkIsReadOnly(data);
        setIsReadOnly(isReadOnly);

        localStorage.setItem("corporateFormData", JSON.stringify(data));
      } else {
        console.error("Failed to fetch corporate structure data:", response.data);
      }
    } catch (error) {
      setFormData(CorporateStructureFactory({}));
      console.error("Error fetching corporate structure data:", error);
    }
  },[checkIsReadOnly]);

  useEffect(()=>{
    if (viewMode || editMode) {
      getCorporateStrucutureByEntityId(sharedData.get("entityId"))
    }
  },[getCorporateStrucutureByEntityId, viewMode, editMode]);

  useEffect(()=>{
    if (!viewMode && !editMode) {
      localStorage.removeItem("corporateFormData");
      getCorporateStrucutureByEntityId(sharedData.get("entityId"));
    }
  }, [editMode, entityId, getCorporateStrucutureByEntityId, viewMode]);

  const [formData, setFormData] = useState(()=>{
    const savedData = localStorage.getItem("corporateFormData");
    console.log("saved",savedData)
    return savedData ? JSON.parse(savedData) : CorporateStructureFactory({});
    
  });

  // Single source of truth for the lock. Previously this was read straight off
  // localStorage on every render while two other places also called setIsReadOnly,
  // which left a window where a validated page rendered unlocked and UBOs could
  // still be deleted.
  const checkStatus = formData.status === "Validated";

  useEffect(() => {
    const isReadOnlyFromURL = searchParams.get("readonly") === "true";
    const isViewMode = searchParams.get("view") === "true";
    setIsReadOnly(isReadOnlyFromURL || isViewMode || checkStatus);
  }, [checkStatus, searchParams]);

  const { validateSingleAddress } = useValidateSingleAddress();
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [pendingUpdatedData, setPendingUpdatedData] = useState(null);
  const [validationResult, setValidationResult] = useState(null);
  const [modalHeading, setModalHeading] = useState("");
  const { modalOpen, setModalOpen } = useModal();
  const [currentUboIndex, setCurrentUboIndex] = useState(0);
  const [uboAddressChanges, setUboAddressChanges] = useState([]);

  
    const sendMail = async (userType,question,response) => {
      showLoader('Sending email, please wait...');
      try {
       
        const payload = {
          requestId: requestId,
          userType: userType,
          Modallabel: question,
          response: response,
          Page: "Corporate Structure"  };
         
        
    
        const data = await utilityService.sendMail(payload); // await is optional if you don't need response
  
  
        console.log("✅ Email sent", data);
        setModalMessage(<EmailSuccess />)
        // setIsModalOpen(true)
        setModalOpen(true);
       
            } catch (error) {
        console.error("❌ Failed to send email:", error);
        setModalMessage(<EmailFailed />)
        // setIsModalOpen(false)
        setModalOpen(true);
     
      }
       hideLoader();
    };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
const [isErrorModalOpen, setIsErrorModalOpen]= useState(false);
  const { validateCorporateStructure, validateUBO } = useValidateCorporateStrcuture();

  const addUBO = useCallback(() => {
    setFormData(prev => {
      if (prev.status === "Validated") return prev;
      const newUBO = { id: uuidv4(), type: '', percentage: '', data: {} };
      const newFormData = {
        ...prev,
        ubos: [...prev.ubos, newUBO]
      };
      localStorage.setItem("corporateFormData", JSON.stringify(newFormData));
      return newFormData;
    });
  }, []);

  const updateUBO = useCallback((id, updatedUBO) => {
    console.log("Update UBO", id, updatedUBO);
    setFormData(prev => {
      if (prev.status === "Validated") return prev;
      const newFormData = {
        ...prev,
        ubos: prev.ubos.map(ubo => 
          ubo.id === id ? updatedUBO : ubo
        )
      };
      localStorage.setItem("corporateFormData", JSON.stringify(newFormData));
      return newFormData;
    });
  }, []);

  const removeUBO = useCallback((id) => {
    setFormData(prev => {
      if (prev.status === "Validated") return prev;
      const newFormData = {
        ...prev,
        ubos: prev.ubos.filter(ubo => ubo.id !== id)
      };
      localStorage.setItem("corporateFormData", JSON.stringify(newFormData));
      return newFormData;
    });
  }, []);

  const handleImportPSC = useCallback((rawItems) => {
    const activeItems = rawItems.filter(item => !item.ceased);

    const newUBOs = activeItems.map(item => {
      const addr = item.address || {};
      return {
        id: uuidv4(),
        type: "Private Individual (Natural Person)",
        percentage: "",
        data: {
          ubofullName: item.name || "",
          uboNationality: item.nationality || "",
          uboaddressLine1: addr.address_line_1 || "",
          uboaddressLine2: addr.address_line_2 || "",
          ubocity: addr.locality || "",
          ubopostalCode: addr.postal_code || "",
          ubocountry: addr.country || "",
        }
      };
    });

    setFormData(prev => {
      if (prev.status === "Validated") return prev;
      const newFormData = {
        ...prev,
        isUbo25Identified: "Yes",
        ubos: [...prev.ubos, ...newUBOs],
      };
      localStorage.setItem("corporateFormData", JSON.stringify(newFormData));
      return newFormData;
    });
  }, []);


  const updateFormData = useCallback((name,value) => {
    setFormData((prev) => {
      const newFormData = {
        ...prev,
        [name]: value,
      };
      localStorage.setItem("corporateFormData", JSON.stringify(newFormData));
      return newFormData;
    });
  },[]);
  const [ModalBorderColor, setModalBorderColor] = useState('');

  const handleSpecialCase = useCallback((name, value) => {
    console.log(name, value);
    if (name === "isUboIdentified") {
      if (value === "Yes") {
        setShowDropdown(true);
        setModalBorderColor('')
      } else {
        setModalMessage(<RequestCertified/>);
        setIsErrorModalOpen(true);
        setModalBorderColor('red');
      }

    } 
 
    else if ( name === "whyUboNotIdentified" ) {
      if (value === "We have not been able to identify the +25% ultimate beneficial owners ") 
        {
      setModalMessage(<DealCheck />);
      setIsErrorModalOpen(true);
      setModalBorderColor('red');
      }
    }
    
    else if ( name === "certifiedStructureChart" ) {
      if (value === "Yes") {
        updateFormData("isUboIdentified", "");
      }
    } else if (name === "outstandingConcern") {
      if (value === "No") {
        updateFormData("concernDetails", "");
      }
    } else if ( name === "isUbo25Identified" ) {
      if ( value === "Yes" ) {
        updateFormData("whyUboNotIdentified", "");
        updateFormData("managedByOne", "");
        updateFormData("threeYearUKAccount", "");
        updateFormData("wellKnownUKCompany", "");
        if (formData.ubos.length === 0) {
          addUBO();
        }
      } else if ( value === "No" ) {
        updateFormData("uboType", "");
        // updateFormData("uboState", { type: '', data: {} })
        updateFormData("ubos", []);
        console.log("Remove DiligenceObservable by Prefix: corporate")
        diligenceObservable.removeByPrefix("corporate");
      }
    } else if ( name === "managedByOne" ) {
      if ( value === "Yes" ) {
        updateFormData("threeYearUKAccount", "");
        updateFormData("wellKnownUKCompany", "");
      }
    }
  },[addUBO, formData.ubos.length, updateFormData]);

  const handleChange = useCallback((e) => {
    setHasUnsavedChanges(true);
    const { name, value } = e.target;
    updateFormData(name, value);
    handleSpecialCase(name, value);
  },[handleSpecialCase, updateFormData]);
  

  const handleSave = async (isValidated = undefined) => {
    setHasUnsavedChanges(false);
    console.log("handle save...", isValidated);
  
    const isAlreadyValidated = formData.status === "Validated";
  
    // ✅ Skip if already validated and user is not explicitly re-validating
    if (isAlreadyValidated && !isValidated) {
      console.log("⏩ Skipping save — already validated and no re-validate triggered.");
      setModalMessage(<PageValidation page={"Corporate Structure"}/>);
      // setIsModalOpen(true);
      setModalOpen(true);
      return;
    }
  
    const payload = corporateStructureApiFactory(requestId, entityId, {
      ...formData,
      status: isValidated ? "Validated" : formData.status
    });
  
    console.log("✅ Payload:", payload);
  
    try {
      const response = await corporateStructureService.saveCorporateStructure(payload);
      console.log(response);
  
      if (response.ok) {
        await applyUboSimplified(formData.isUbo25Identified === "Yes" ? formData.ubos : []);
        setModalMessage(<SaveResultMessage isValidated={isValidated} message={response.data.message} />);
        // setIsModalOpen(true);
        setModalOpen(true);
      } else {
        const errorMsg = response.data?.error || "Unexpected error occurred";
        console.error("❌ Error:", errorMsg);
        setModalMessage(<ErrorMessage message={errorMsg} />);
        // setIsModalOpen(true);
        setModalOpen(true);
      }
    } catch (error) {
      console.error("❌ Error saving data:", error);
      setModalMessage(<SaveFailed />);
      // setIsModalOpen(true);
      setModalOpen(true);
    }
  
    // ✅ Refresh data after save
    getCorporateStrucutureByEntityId(entityId);
  };
  
  

  const checkHasErrors = useCallback((totalErrors) => {
    if (!totalErrors || totalErrors.length === 0) return false;
  
    for (let itemObject of totalErrors) {
      if (itemObject && Object.keys(itemObject).length > 0) {
        let keys = Object.keys(itemObject);
  
        // If there are keys other than 'nomieeErrors'
        const otherKeys = keys.filter((key) => key !== 'nomieeErrors');
        if (otherKeys.length > 0) {
          for (let key of otherKeys) {
            if (Array.isArray(itemObject[key]) && itemObject[key].length > 0) {
              return true;
            }
          }
        }
  
        // If only 'nomieeErrors' exists
        if ('nomieeErrors' in itemObject) {
          const nomieeErrors = itemObject.nomieeErrors;
          if (Array.isArray(nomieeErrors) && nomieeErrors.length > 0) {
            for (let nomiee of nomieeErrors) {
              if (nomiee && Object.keys(nomiee).length > 0) {
                return true;
              }
            }
          }
        } else {
          // nomieeErrors key doesn't exist but object has something ⇒ return true
          return true;
        }
      }
    }
  
    return false;
  }, []);
  
  const handleValidate = async () => {
    const isAlreadyValidated = formData.status === "Validated";
  
    if (isAlreadyValidated) {
      console.log("⏩ Skipping save — already validated and no re-validate triggered.");
      setModalMessage(<PageValidation page={"Corporate Structure"}/>);
      // setIsModalOpen(true);
      setModalOpen(true);
      return;
    }
  
    console.log("handle validate ...");
  
    setModalMessage(<Validating/>);
    // setIsModalOpen(true);
    setModalOpen(true);
  
    // Validate Corporate Structure
    const corporateErrors = validateCorporateStructure(formData);
  
    // Validate UBOs if needed
    let uboErrorsList = [];
    // Validate whatever UBOs are actually on the page. Gating this on
    // isUbo25Identified let a page with filled-in UBOs validate while their required
    // answers (sole director, met face to face) were still blank.
    if (formData.ubos?.length) {
      for (const ubo of formData.ubos) {
        const errors = validateUBO(ubo);
        uboErrorsList.push(errors);
      }
    }
  
    const hasCorporateErrors = corporateErrors && Object.keys(corporateErrors).length > 0;
    const hasUboErrors = checkHasErrors(uboErrorsList);
  
    // If any errors exist, show them all together
    if (hasCorporateErrors || hasUboErrors) {
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>Validation Result</h2>
          <strong>Please fill in the following required fields:</strong>
          <br />
          <div style={{ maxHeight: "400px", overflow: "auto", padding: "10px" }}>
            {/* Show Corporate Structure Errors */}
            {hasCorporateErrors && (
              <div style={{ marginBottom: "20px" }}>
                <ul style={{ marginLeft: "20px" }}>
                  {Object.keys(corporateErrors).map((field) => (
                    <li key={field}>
                      {corporateErrors[field].map((error, index) => (
                        <div key={index}>{error}</div>
                      ))}
                    </li>
                  ))}
                </ul>
              </div>
            )}
  
            {/* Show UBO Errors */}
            {hasUboErrors && (
              <div>
                {uboErrorsList.map((uboErrors, uboIndex) => (
                  <div key={uboIndex} style={{ marginBottom: "15px" }}>
                    {Object.keys(uboErrors).length > 0 && (
                      <>
                        <strong>UBO {uboIndex + 1}:</strong>
                        <ul style={{ marginLeft: "20px" }}>
                          {Object.entries(uboErrors).map(([field, errors]) => {
                            if (field === "nomieeErrors") {
                              return (
                                errors && errors.length > 0 && errors.some(error => error && Object.keys(error).length > 0) && (
                                  <li key={field}>
                                    <strong>Nominees:</strong>
                                    <ul style={{ marginLeft: "20px" }}>
                                      {errors.map((nomineeError, nomineeIndex) => (
                                        nomineeError && (
                                          <li key={nomineeIndex}>
                                            <strong>Nominee {nomineeIndex + 1}:</strong>
                                            <ul style={{ marginLeft: "20px" }}>
                                              {Object.entries(nomineeError).map(
                                                ([nField, nErrors]) => (
                                                  <li key={nField}>
                                                    {nErrors.map((error, errorIndex) => (
                                                      <div key={errorIndex}>{error}</div>
                                                    ))}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </li>
                                        )
                                      ))}
                                    </ul>
                                  </li>
                                )
                              );
                            }
                            return (
                              <li key={field}>
                                {errors.map((error, errorIndex) => (
                                  <div key={errorIndex}>{error}</div>
                                ))}
                              </li>
                            );
                          })}
                        </ul>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      );
  
      // setIsModalOpen(true);
      setModalOpen(true);
      return; // Don't save if there are errors
    }
  
    // No Errors => Save
    await handleSave(true);

    getCorporateStrucutureByEntityId(entityId);

    console.log("formData before:",formData)
    let finalFormData = JSON.parse(JSON.stringify(formData)); // declare before validation
  
    try {
      // ✅ Run validation first to get updated addresses
      const { valid, data: validatedFormData } = await handleAddressValidation({
        formData,
        setFormData,
        setModalOpen: setIsModalOpen,
        setModalHeading,
        setModalMessage,
        setValidationResult,
        setPendingUpdatedData,
        setShowAddressModal,
        validateSingleAddress,
        setUboAddressChanges,
        setCurrentUboIndex
      });

      if (valid && validatedFormData) {
        finalFormData = JSON.parse(JSON.stringify(validatedFormData));
        setFormData(finalFormData);
        localStorage.setItem("corporateFormData", JSON.stringify(finalFormData));
      }
  
      // ✅ Build payload AFTER validation
      const payload = corporateStructureApiFactory(requestId, entityId, {
        ...finalFormData,
        status: "Validated",
      });
      console.log("✅ Payload:", payload);
  
      const response = await corporateStructureService.saveCorporateStructure(payload);

      if (response.ok) {
        await applyUboSimplified(finalFormData.isUbo25Identified === "Yes" ? finalFormData.ubos : []);
        setModalMessage(<SaveResultMessage isValidated={true} message={response.data.message} />);
        // setIsModalOpen(true);
        setModalOpen(true);
        setTimeout(() => {
          // setIsModalOpen(false); // Close modal first
          setModalOpen(false);
        }, 500);
        reloadAfterValidate(500);
        
        return true;
      } else {
        const errorMsg = response.data?.error || "Unexpected error occurred";
        console.error("❌ Error:", errorMsg);
        setModalMessage(<ErrorMessage message={errorMsg} />);
        // setIsModalOpen(true);
        setModalOpen(true);
        return false;
      }
    } catch (error) {
      console.error("❌ Error saving data:", error);
      setModalMessage(<SaveFailed />);
      // setIsModalOpen(true);
      setModalOpen(true);
    }
  };

  
  // const handleNext = async () => {
  //   await handleSave();
  //   navigate("/management-structure?" + searchParams.toString());
  // };



  const handleNext = useCallback(async () => {
    await handleSave();
    console.log("formData after save:", formData);
    const value = formData?.ubos?.[0]?.data?.ubosoleDirector;
    // const value = formData.ubos[0].data.ubosoleDirector

    // Check Client/Counterparty completion status
    const clientFormData = localStorage.getItem("clientFormData");
    let isClientCounterpartyCompleted = false;
    if (clientFormData) {
      const parsedData = JSON.parse(clientFormData);
      isClientCounterpartyCompleted = parsedData.entityStatus === "Validated" || parsedData.status === "Validated";
    }

    if (value === "Yes") {
      try {
        const payload2 = {
          entityId: entityId,
          data: "[]",  // adjust this if needed
          status: "Validated",
        };

        const mgmtResp = await managementStructureService.saveManagementStructure(payload2);

        if (mgmtResp?.status === 200 || mgmtResp?.ok) {
          console.log("✅ Management structure saved. Navigating to next enabled section...");
          // Use navigation helper to skip disabled sections
          const nextPath = getNextEnabledSection('/corporate-structure', {
            isEntityIdMissing: !entityId,
            isClientCounterpartyCompleted,
            searchParams
          });
          navigate(nextPath);
        } else {
          console.warn("⚠️ Management structure save failed.", mgmtResp);
        }
      } catch (error) {
        console.error("❌ Error saving management structure:", error);
        setModalMessage(
          <>
            <strong>Error: {error.message || "Failed to update management structure"}</strong>
          </>
        );
        setIsModalOpen(true);
      }
    } else {
      // Use navigation helper to determine next enabled section
      const nextPath = getNextEnabledSection('/corporate-structure', {
        isEntityIdMissing: !entityId,
        isClientCounterpartyCompleted,
        searchParams
      });
      navigate(nextPath);
    }
  }, [formData, handleSave, entityId, searchParams, navigate]);


  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  
  return (
    <>
      
      <div className={!isReport ? "transaction-detail" : ""}>
        {!isReport && <StepTabs hasUnsavedChanges={hasUnsavedChanges} searchParams={searchParams}/>}
        <ViewModeBanner
          isReadOnly={isReadOnly}
          status={formData?.status}
        />
        <div className="form-section">
        <CorporateStructureForm isReport={isReport} formData={formData} handleChange={handleChange} isReadOnly={isReadOnly} onUpdateUBO={updateUBO} onRemoveUBO={removeUBO} onAddUBO={addUBO} sendMail={sendMail} diligenceStatus={diligenceStatus} onImportPSC={handleImportPSC} />
        {!isReport && <RightSidebar
        corporateStructureData={formData}
      />}
      </div>
      </div>
      {!isReport && <BottomBar
        buttons={[
          { label: "Save", onClick: ()=>{handleSave(false);},skipConfirmation: true ,  disabled:checkStatus},  
          { label: "Validate & Lock", onClick: handleValidate, disabled:checkStatus },
           {
      label: "Back",
      onClick: () => navigate(`/client-counter?${searchParams.toString()}`),
      style: {},
      title: "Go back",
      disabled: false,
    },
          { label: "Next",onClick: handleNext}
        
      ]}
      />}
       <LoaderModal isOpen={isLoading} message={loadingMessage} />
   
       <ConfirmationModal
              isOpen={modalOpen}
              heading= {modalHeading}
              message={modalMessage}
              onClose={() => setModalOpen(false)}
            />
   
       <ErrorModal
        isOpen={isErrorModalOpen}
        message={modalMessage}
        onClose={() => setIsErrorModalOpen(false)}
      />
      <FloatingQueryCenter />
          {showAddressModal && currentUboIndex < uboAddressChanges.length && validationResult && (
          <Modal
            modalHeading={`Address Validation - Ubo ${currentUboIndex + 1}`}
            modalMessage={
              <AddressUpdateConfirmationModal
              formData={uboAddressChanges[currentUboIndex]?.formData}
              updatedData={uboAddressChanges[currentUboIndex]?.updatedData}
              onContinue={validationResult.handleContinue}
              onDiscard={validationResult.handleDiscard}
              />
            }
            onClick={() => setShowAddressModal(false)}
          />
        )}
    </>
  );
};

export default CorporateStructure;